// AssignmentPicker client for a Real Estate transaction (ticket 206). Same three calls as the
// loan-file picker, pointed at /re/transactions/:id/assignments (slots; `loans.assign` to change).
import { api } from '../api';

export const txAssignments = {
  list: (id) => api.get(`/re/transactions/${id}/assignments`).then((r) => r.data),
  add: (id, body) => api.post(`/re/transactions/${id}/assignments`, body).then((r) => r.data),
  remove: (id, userId, slot) => api.delete(`/re/transactions/${id}/assignments/${userId}`, { params: slot ? { slot } : {} }).then((r) => r.data),
};
